import React, { useCallback, useEffect, useState } from 'react';
import { API_BASE_URL } from '../lib/apiClient';
import ServiceUnavailable from '../pages/ServiceUnavailable';
import LoadingState from './ui/LoadingState';

const BackendHealthGate = ({ children }) => {
  const [status, setStatus] = useState({ loading: true, healthy: true });

  const checkHealth = useCallback(async () => {
    setStatus((prev) => ({ ...prev, loading: true }));

    try {
      const response = await fetch(`${API_BASE_URL}/health`, {
        method: 'GET',
        cache: 'no-store',
      });

      if (!response?.ok) {
        throw new Error('Health check failed');
      }

      setStatus({ loading: false, healthy: true });
    } catch (error) {
      setStatus({ loading: false, healthy: false });
    }
  }, []);

  useEffect(() => {
    checkHealth();
  }, [checkHealth]);

  if (status.loading) {
    return (
      <div className="min-h-screen bg-background">
        <LoadingState message="Checking service status…" />
      </div>
    );
  }

  if (!status.healthy) {
    return <ServiceUnavailable onRetry={checkHealth} />;
  }

  return children;
};

export default BackendHealthGate;
